const enUS = {
    crossmintPayButtonService: {
        CONNECTING: "Đang kết nối",
        BUY_WITH_ETH: "Mua bằng ETH",
        BUY_WITH_SOL: "Mua bằng SOL",
        BUY_WITH_CREDIT_CARD: "Mua bằng thẻ tín dụng",
    },
};
export default enUS;
